/*
 * @Description: Display image with responsive container
 * @Author: Jack Deng
 * @Date: 2021-03-09 15:05:13
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-11-04 14:40:52
 * @FilePath: /unifyxp-v2-store-portal/src/components/Upload/ImageDisplay/AntdImageDisplay.tsx
 */

import React from 'react';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';
import { Image } from 'src/components/Antd';
import styles from './css.module.less';

export enum Type {
  Responsive = 'Responsive', //其他用
  Fill = 'Fill', //上传专用
}

function AntdImageDisplay(props) {
  const {
    type,
    src,
    width,
    height,
    hideAction,
    hideRemove,
    style,
    className,
    hideEdit,

    onRemove,
    hasOptionsLayer,
  } = props;
  // const image = fileList[fileList.length - 1];
  const [visible, setVisible] = React.useState(false);
  return (
    <div
      className={styles.container}
      style={{
        width: type === Type.Responsive ? width : width || undefined,
        height,
        ...(style || {}),
      }}>
      <Image
        {...(hasOptionsLayer
          ? {
              preview: {
                visible,
                onVisibleChange: (v) => {
                  setVisible(v);
                },
              },
            }
          : {})}
        src={src}
        width={width}
        height={height}
        className={className}
      />

      {!hideAction && (
        <div className={styles.action}>
          <div className={styles.content}>
            {!hideEdit && (
              <span className={styles.actionBtn}>
                <EditOutlined
                  className={styles.icon}
                  onClick={() => {
                    //console.log('edit');
                    setVisible(true);
                  }}
                />
              </span>
            )}
            {!hideRemove && (
              <span
                className={styles.actionBtn}
                style={{ color: '#FF695F' }}
                onClick={onRemove}>
                <DeleteOutlined className={styles.icon} />
              </span>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default AntdImageDisplay;
